module.exports = __webpack_public_path__ + "img/board-4.193c908c.png";